<template>
  <div class="myPagePanel">
    <div class="myPagePanel__item" v-for="panel in panelList" :key="panel.menu">
      <b-image class="icon" :src="require('../assets/image/mypage/' + panel.icon + '.png')" :rounded="true"/>
      <div class="myPagePanel__item__content">
        <p class="name">{{panel.name}}</p>
        <p class="text">{{panel.text}}</p>
      </div>
      <b-button class="is-fullwidth" @click="move(panel.menu)" >{{panel.buttonText}}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPagePanel',
  props: {
    panelList: { type: Array }
  },
  methods: {
    move(menu) {
      this.$emit('select', menu);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../assets/scss/myPagePanel.scss';
</style>
